<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-07-14 10:23:42
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-11-25 18:00:57
 * @FilePath: \mrc-base-server-view\src\views\o_f_manage\department_manage\index.vue
-->
<template>
  <!-- 部门管理 -->
  <div>
    <div v-if="$route.name == 'department_manage'">
      <mrc_ess_iconGroup :showEdit="false"
                         :show_del="false">
        <!-- <v-btn small
               tag="a"
               depressed
               height="40"
               v-btnAuth="['download-organization-template']"
               :href="uploadUrl"
               rounded
               class="ml-4 white--text text-button"
               color="primary">
          {{ $t('label_Download_the_template') }}
        </v-btn> -->
        <mrc_ess_uploadBtn type="2"
                           class="ml-4"
                           :hrefUrl="uploadUrl"
                           v-btnAuth="['import-department']"
                           table="mrbase_sys_org_levels"
                           :label="$t('label_Batch_Import')">
        </mrc_ess_uploadBtn>
      </mrc_ess_iconGroup>
      <mrc_ess_skeleton_loader :loading="skLoading">
        <v-card>
          <v-card-text>
            <div class="text--secondary pb-3 pl-10">
              <!-- {{ $t('label_client') }}/{{ $t('label_company_unit') }} -->
              {{$t('label_depart_m_name')}}
            </div>
            <template v-if="Array.isArray(companyList) && companyList.length > 0">
              <div v-for="(treelist,index) in companyList"
                   :key="index"
                   :class="index!==0?'mt-5':''"
                   style="border-radius:8px;border: 1px solid #e8e8e8;">
                <v-treeview hoverable
                            open-on-click
                            selected-color="primary"
                            transition
                            item-key="uuid"
                            item-children="children"
                            expand-icon="arrow_drop_down"
                            :items="[treelist]">
                  <template v-slot:label="{ item }">
                    {{ INT(item.org_level_name) }}
                  </template>
                  <template v-slot:append="{ item }">
                    <!-- <v-btn icon>
                      <i class="material-icons"
                         @click.stop="clickHandler($event, item)">remove_red_eye</i>
                    </v-btn> -->
                    <mrc_ess_svgIcon @click.stop.native="clickHandler($event, item)"
                                     iconClass="view_detail"
                                     style="font-size: 23px;" />
                  </template>
                </v-treeview>
              </div>
            </template>
            <template v-else>
              <mrc_ess_noContent></mrc_ess_noContent>
            </template>
          </v-card-text>
        </v-card>
      </mrc_ess_skeleton_loader>
    </div>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import { ORG_URL } from '@/utils/constant/index.js'
import { get_company_list } from '@/service/api/company_set'
export default {
  components: {},
  props: {},
  data () {
    return {
      uploadUrl: '',
      companyList: [],
      skLoading: true,
    }
  },
  created () {
    this.uploadUrl = ORG_URL
  },
  async mounted () {
    if (this.$route.name == 'department_manage') {
      await this.getBtnPermissionList()
      await this.getList()
      this.skLoading = false
    }
  },
  methods: {
    // 获取公司列表
    async getList () {
      this.skLoading = true
      let obj = {}
      if (this.$store.state.userData.userType == 2) {
        obj = {
          client_uuid: this.$store.state.currentCompanyClientUuid,
          org_level_uuid: this.$store.state.currentCompanyObj.uuid,
          org_level_code: this.$store.state.currentCompanyObj.org_level_code,
        }
      } else {
        obj = {
          client_uuid: this.$store.state.currentCompanyClientUuid,
        }
      }
      const list = await get_company_list(obj)
      if (list.code == 200) {
        this.companyList = list.data
      }
      this.skLoading = false
    },
    clickHandler (obj, item) {
      this.$store.commit('set_subPage_name', item.org_level_name)
      this.$store.commit('setOrgLevelCode', item.org_level_code)
      this.$store.commit('set_uuid', item.uuid)
      this.$router.push({
        name: 'department_list',
        params: {
          name: item.org_level_name,
          uuid: item.uuid,
          code: item.org_level_code,
        },
      })
    },
    // 跳转部门列表页
    // handleAdd() {
    //   this.$store.commit('set_subPage_name', '')
    //   this.$store.commit('set_uuid', '')
    //   this.$router.push({
    //     name: 'department_list'
    //   })
    // },
  },
  computed: {},
  watch: {
    async $route (val) {
      if (val.name == 'department_manage') {
        await this.getList()
        this.$store.commit('setTab', 0)
      }
    },
  },
}
</script>

<style scoped>
/* /deep/ .v-treeview-node {
  margin-bottom: 12px;
  border-bottom: 1px solid #e8e8e8;
  border-radius: 8px;
}
/deep/ .v-treeview-node__root:first-of-type {
  border-radius: 8px;
}
/deep/ .v-treeview-node__root {
  border: 1px solid #e8e8e8;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  border-bottom: none;
  height: 60px;
}
/deep/ .v-treeview-node__children .v-treeview-node,
/deep/ .v-treeview-node__children .v-treeview-node__root {
  border-bottom: none;
  margin-bottom: 0;
  border-radius: inherit;
}
/deep/
  .v-treeview-node__children:last-child
  .v-treeview-node:last-child
  .v-treeview-node__root:last-child {
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
}
/deep/ .v-treeview-node__root:last-child {
  border-top-right-radius: inherit;
  border-top-left-radius: inherit;
} */
</style>
